import { Flex, Modal, Title, createStyles } from "@mantine/core";
import greenCheck from '../assets/img/greenCheck.svg';
import dots from "../assets/img/dots.svg"
import { platformLogo } from "../utils";



const useStyles = createStyles((theme) => ({
    connectingText: {
        fontSize: "22px",
        fontWeight: "bold"
    },
    icon: {
        height: "35px",
        marginLeft: "5px",
        marginBottom: "4px"
    },
    epicLogo: {
        height: "50px",
        width: "80px",
    }
  }));

export function ConnectingModal(props: any) {
    const { classes } = useStyles();

    return (
            <Modal
                opened={props.isOpen}
                onClose={() => {props.onClose()}}
                size={"lg"}
                withCloseButton={false}
                centered
            >
                 <Flex
                    mih={350}
                    justify="center"
                    align="center"
                    direction={"column"}
                    gap={"20px"}
                    >
                    <img src={platformLogo[props.vendor?.replace(/\s/g, '')?.toLowerCase()]} alt="" className={classes.epicLogo}/>
                    <Title className={classes.connectingText}>
                       { props.isConnecting ? "Connecting" : "Connected"} 
                       {!props.isConnecting ? <img src={greenCheck}  alt="" className={classes.icon}/>: <img src={dots}  alt="" className={classes.icon}/> } 
                    </Title>
                    <Title size={"xl"}>{ props.isConnecting ? `Please wait, we are connecting to ${props.vendor}` : `Connected to ${props.vendor}`} </Title>
                </Flex>
            </Modal>
    )
}